/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { GetWindParkSelect, SetCurrentPark } from "@/stores/actions/WindParkSelect";

const state = {
	status:         FetchStatus.Init,
	successMessage: "",
	errorMessage:   "",
	errorHeade:     "",
	data:           {},
	selectItens:    [],
	currentPark:    {},
};

const actions = {

	[GetWindParkSelect]: ({ commit }, data) =>
	{
		const windParksArray = [];
		for (let i = 0; i < data.length; i++)
		{
			// Obtém o parque/usina iterado.
			let park = data[i];

			// Navega nos filhos dos parque/usinas, no caso as turbinas/unidade geradoras.
			for (let j = 0; j < park.monitoringElementChild.length; j++)
			{
				// Obtém a turbina iterada.
				let asset = park.monitoringElementChild[j];
				const item = {};
				item.id = asset.id;
				item.name = asset.name;
				item.routeName = "WindPark";
				windParksArray.push(item);
			}
		}
		commit(GetWindParkSelect, windParksArray);
	},
	[SetCurrentPark]: ({ commit }, data) =>
	{
		const current = {};
		current.id = data.id;
		current.name = data.name;

		commit(SetCurrentPark, current);
	},

};
const mutations = {
	[GetWindParkSelect]: (state, data) =>
	{
		state.selectItens = data;
	},
	[SetCurrentPark]: (state, data) =>
	{
		state.currentPark = data;
	},
};

export default {
	state,
	actions,
	mutations,
};
